<template>
    <v-dialog
      v-model="showTooltip"
      max-width="400px"
      scrollable
      @keydown.esc="onClose"
      @click:outside="onClose"
    >
      <v-card>
        <v-card-title>
          {{ translate('ui_dialog_view_hint_header') }}
        </v-card-title>

        <v-card-text v-html="translate('ui_dialog_view_hint_content')">
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="onClose"
          >
            {{ translate('ui_close_btn') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
// mixins
import Mixin from '../../../mixins/mixin';

export default {
  components: {},
  props: {
    showTooltip: Boolean,
  },
  mixins: [Mixin],
  methods: {
    onClose() {
      this.$emit('closeDialogHintAssumptions');
    },
  },
  computed: {},
};
</script>
